import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

// Mock data dos iPhones
const iphones = [
  // iPhone XR (2018)
  {
    id: 1,
    name: 'iPhone XR',
    year: '2018',
    image: 'https://public.readdy.ai/ai/img_res/446027ff3875082738b2233dfe1042c5.jpg',
    chip: 'A12 Bionic',
    display: '6.1" Liquid Retina',
    camera: 'Câmara única 12MP',
    capacities: ['64GB', '128GB', '256GB'],
    colors: ['Azul', 'Branco', 'Preto', 'Amarelo', 'Coral', 'Vermelho'],
    features: ['Face ID', 'Resistente à água IP67', 'Carregamento sem fios']
  },
  // iPhone 11 Series
  {
    id: 2,
    name: 'iPhone 11',
    year: '2019',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2011%20with%20dual%20camera%20system%20in%20purple%20green%20yellow%20red%20white%20black%20colors%2C%20Apple%20smartphone%20with%20aluminum%20frame%20and%20glass%20back%2C%20professional%20product%20photography%2C%20clean%20background&width=300&height=300&seq=iphone-11-002&orientation=squarish',
    chip: 'A13 Bionic',
    display: '6.1" Liquid Retina',
    camera: 'Câmara dupla 12MP',
    capacities: ['64GB', '128GB', '256GB'],
    colors: ['Roxo', 'Amarelo', 'Verde', 'Preto', 'Branco', 'Vermelho'],
    features: ['Face ID', 'Modo Noturno', 'Ultra Wide Camera']
  },
  {
    id: 3,
    name: 'iPhone 11 Pro',
    year: '2019',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2011%20Pro%20with%20triple%20camera%20system%20in%20space%20gray%20silver%20gold%20midnight%20green%2C%20premium%20stainless%20steel%20frame%2C%20professional%20product%20photography%2C%20luxury%20smartphone%20design&width=300&height=300&seq=iphone-11-pro-002&orientation=squarish',
    chip: 'A13 Bionic',
    display: '5.8" Super Retina XDR',
    camera: 'Câmara tripla 12MP',
    capacities: ['64GB', '256GB', '512GB'],
    colors: ['Space Gray', 'Prata', 'Dourado', 'Verde Meia-Noite'],
    features: ['Face ID', 'ProRAW', 'Zoom óptico 2x']
  },
  {
    id: 4,
    name: 'iPhone 11 Pro Max',
    year: '2019',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2011%20Pro%20Max%20large%20screen%20with%20triple%20camera%20system%2C%20premium%20stainless%20steel%20smartphone%20in%20space%20gray%20silver%20gold%20colors%2C%20professional%20product%20photography%2C%20flagship%20mobile%20device&width=300&height=300&seq=iphone-11-pro-max-002&orientation=squarish',
    chip: 'A13 Bionic',
    display: '6.5" Super Retina XDR',
    camera: 'Câmara tripla 12MP',
    capacities: ['64GB', '256GB', '512GB'],
    colors: ['Space Gray', 'Prata', 'Dourado', 'Verde Meia-Noite'],
    features: ['Face ID', 'ProRAW', 'Bateria até 20h']
  },
  // iPhone SE Series
  {
    id: 5,
    name: 'iPhone SE (2020)',
    year: '2020',
    image: 'https://readdy.ai/api/search-image?query=iPhone%20SE%202020%20compact%20design%20with%20home%20button%20in%20white%20black%20red%20colors%2C%20classic%20Apple%20smartphone%20with%20aluminum%20frame%2C%20professional%20product%20photography%2C%20budget-friendly%20device&width=300&height=300&seq=iphone-se-2020-002&orientation=squarish',
    chip: 'A13 Bionic',
    display: '4.7" Retina HD',
    camera: 'Câmara única 12MP',
    capacities: ['64GB', '128GB', '256GB'],
    colors: ['Branco', 'Preto', 'Vermelho'],
    features: ['Touch ID', 'Compacto', 'A13 Bionic']
  },
  {
    id: 6,
    name: 'iPhone SE (2022)',
    year: '2022',
    image: 'https://readdy.ai/api/search-image?query=iPhone%20SE%202022%20with%205G%20connectivity%20and%20home%20button%2C%20compact%20smartphone%20in%20midnight%20starlight%20red%20colors%2C%20Apple%20budget%20device%20with%20premium%20chip%2C%20professional%20photography&width=300&height=300&seq=iphone-se-2022-002&orientation=squarish',
    chip: 'A15 Bionic',
    display: '4.7" Retina HD',
    camera: 'Câmara única 12MP',
    capacities: ['64GB', '128GB', '256GB'],
    colors: ['Meia-Noite', 'Starlight', 'Vermelho'],
    features: ['Touch ID', '5G', 'A15 Bionic']
  },
  // iPhone 12 Series
  {
    id: 7,
    name: 'iPhone 12 mini',
    year: '2020',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2012%20mini%20compact%205G%20smartphone%20with%20dual%20camera%20system%20in%20blue%20green%20black%20white%20red%20purple%20colors%2C%20MagSafe%20compatible%2C%20professional%20product%20photography&width=300&height=300&seq=iphone-12-mini-002&orientation=squarish',
    chip: 'A14 Bionic',
    display: '5.4" Super Retina XDR',
    camera: 'Câmara dupla 12MP',
    capacities: ['64GB', '128GB', '256GB'],
    colors: ['Azul', 'Verde', 'Preto', 'Branco', 'Vermelho', 'Roxo'],
    features: ['Face ID', '5G', 'MagSafe']
  },
  {
    id: 8,
    name: 'iPhone 12',
    year: '2020',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2012%20with%205G%20technology%20and%20dual%20camera%20system%20in%20blue%20green%20black%20white%20red%20purple%20colors%2C%20aluminum%20frame%20with%20Ceramic%20Shield%2C%20professional%20photography&width=300&height=300&seq=iphone-12-002&orientation=squarish',
    chip: 'A14 Bionic',
    display: '6.1" Super Retina XDR',
    camera: 'Câmara dupla 12MP',
    capacities: ['64GB', '128GB', '256GB'],
    colors: ['Azul', 'Verde', 'Preto', 'Branco', 'Vermelho', 'Roxo'],
    features: ['Face ID', '5G', 'Ceramic Shield']
  },
  {
    id: 9,
    name: 'iPhone 12 Pro',
    year: '2020',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2012%20Pro%20with%20triple%20camera%20system%20and%20LiDAR%20scanner%20in%20graphite%20gold%20silver%20pacific%20blue%2C%20stainless%20steel%20premium%20smartphone&width=300&height=300&seq=iphone-12-pro-002&orientation=squarish',
    chip: 'A14 Bionic',
    display: '6.1" Super Retina XDR',
    camera: 'Câmara tripla 12MP + LiDAR',
    capacities: ['128GB', '256GB', '512GB'],
    colors: ['Grafite', 'Dourado', 'Prata', 'Azul Pacífico'],
    features: ['Face ID', 'ProRAW', 'LiDAR Scanner']
  },
  {
    id: 10,
    name: 'iPhone 12 Pro Max',
    year: '2020',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2012%20Pro%20Max%20large%20screen%20with%20advanced%20triple%20camera%20system%20and%20sensor-shift%20stabilization%2C%20premium%20stainless%20steel%20smartphone%2C%20professional%20photography&width=300&height=300&seq=iphone-12-pro-max-002&orientation=squarish',
    chip: 'A14 Bionic',
    display: '6.7" Super Retina XDR',
    camera: 'Câmara tripla 12MP + LiDAR',
    capacities: ['128GB', '256GB', '512GB'],
    colors: ['Grafite', 'Dourado', 'Prata', 'Azul Pacífico'],
    features: ['Face ID', 'Sensor-shift OIS', 'Zoom óptico 2.5x']
  },
  // iPhone 13 Series
  {
    id: 11,
    name: 'iPhone 13 mini',
    year: '2021',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2013%20mini%20compact%20smartphone%20with%20improved%20battery%20life%20and%20dual%20camera%20system%20in%20pink%20blue%20midnight%20starlight%20red%2C%20professional%20product%20photography&width=300&height=300&seq=iphone-13-mini-002&orientation=squarish',
    chip: 'A15 Bionic',
    display: '5.4" Super Retina XDR',
    camera: 'Câmara dupla 12MP',
    capacities: ['128GB', '256GB', '512GB'],
    colors: ['Rosa', 'Azul', 'Meia-Noite', 'Starlight', 'Vermelho'],
    features: ['Face ID', 'Modo Cinema', 'Bateria melhorada']
  },
  {
    id: 12,
    name: 'iPhone 13',
    year: '2021',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2013%20with%20cinematic%20mode%20and%20improved%20cameras%20in%20pink%20blue%20midnight%20starlight%20red%20colors%2C%20aluminum%20frame%20smartphone%2C%20professional%20photography&width=300&height=300&seq=iphone-13-002&orientation=squarish',
    chip: 'A15 Bionic',
    display: '6.1" Super Retina XDR',
    camera: 'Câmara dupla 12MP',
    capacities: ['128GB', '256GB', '512GB'],
    colors: ['Rosa', 'Azul', 'Meia-Noite', 'Starlight', 'Vermelho'],
    features: ['Face ID', 'Modo Cinema', 'A15 Bionic']
  },
  {
    id: 13,
    name: 'iPhone 13 Pro',
    year: '2021',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2013%20Pro%20with%20ProMotion%20120Hz%20display%20and%20triple%20camera%20system%20in%20graphite%20gold%20silver%20sierra%20blue%2C%20stainless%20steel%20premium%20device&width=300&height=300&seq=iphone-13-pro-002&orientation=squarish',
    chip: 'A15 Bionic',
    display: '6.1" Super Retina XDR ProMotion',
    camera: 'Câmara tripla 12MP + LiDAR',
    capacities: ['128GB', '256GB', '512GB', '1TB'],
    colors: ['Grafite', 'Dourado', 'Prata', 'Azul Sierra'],
    features: ['Face ID', 'ProMotion 120Hz', 'Zoom óptico 3x']
  },
  {
    id: 14,
    name: 'iPhone 13 Pro Max',
    year: '2021',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2013%20Pro%20Max%20large%20screen%20with%20ProMotion%20technology%20and%20advanced%20triple%20camera%20system%2C%20flagship%20stainless%20steel%20smartphone%2C%20professional%20photography&width=300&height=300&seq=iphone-13-pro-max-002&orientation=squarish',
    chip: 'A15 Bionic',
    display: '6.7" Super Retina XDR ProMotion',
    camera: 'Câmara tripla 12MP + LiDAR',
    capacities: ['128GB', '256GB', '512GB', '1TB'],
    colors: ['Grafite', 'Dourado', 'Prata', 'Azul Sierra'],
    features: ['Face ID', 'ProMotion 120Hz', 'Bateria até 28h']
  },
  // iPhone 14 Series
  {
    id: 15,
    name: 'iPhone 14',
    year: '2022',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2014%20with%20improved%20cameras%20and%20safety%20features%20in%20blue%20purple%20midnight%20starlight%20red%20colors%2C%20aluminum%20frame%20smartphone%20with%20notch%20design&width=300&height=300&seq=iphone-14-002&orientation=squarish',
    chip: 'A15 Bionic',
    display: '6.1" Super Retina XDR',
    camera: 'Câmara dupla 12MP',
    capacities: ['128GB', '256GB', '512GB'],
    colors: ['Azul', 'Roxo', 'Meia-Noite', 'Starlight', 'Vermelho'],
    features: ['Face ID', 'Detecção de Acidente', 'SOS Emergência']
  },
  {
    id: 16,
    name: 'iPhone 14 Plus',
    year: '2022',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2014%20Plus%20large%20screen%20smartphone%20with%20dual%20camera%20system%20and%20improved%20battery%20life%2C%20aluminum%20frame%20smartphone%20with%20extended%20battery%20life%2C%20professional%20product%20photography&width=300&height=300&seq=iphone-14-plus-002&orientation=squarish',
    chip: 'A15 Bionic',
    display: '6.7" Super Retina XDR',
    camera: 'Câmara dupla 12MP',
    capacities: ['128GB', '256GB', '512GB'],
    colors: ['Azul', 'Roxo', 'Meia-Noite', 'Starlight', 'Vermelho'],
    features: ['Face ID', 'Ecrã grande', 'Bateria até 26h']
  },
  {
    id: 17,
    name: 'iPhone 14 Pro',
    year: '2022',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2014%20Pro%20with%20Dynamic%20Island%20and%20triple%20camera%20system%20in%20space%20black%20silver%20gold%20deep%20purple%2C%20stainless%20steel%20premium%20smartphone&width=300&height=300&seq=iphone-14-pro-002&orientation=squarish',
    chip: 'A16 Bionic',
    display: '6.1" Super Retina XDR ProMotion',
    camera: 'Câmara tripla 48MP + LiDAR',
    capacities: ['128GB', '256GB', '512GB', '1TB'],
    colors: ['Space Black', 'Prata', 'Dourado', 'Roxo Profundo'],
    features: ['Face ID', 'Dynamic Island', 'Always-On Display']
  },
  {
    id: 18,
    name: 'iPhone 14 Pro Max',
    year: '2022',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2014%20Pro%20Max%20flagship%20with%20titanium%20construction%20and%20tetraprism%20telephoto%20camera%2C%20premium%20stainless%20steel%20smartphone%20with%20advanced%20zoom%20capabilities&width=300&height=300&seq=iphone-14-pro-max-002&orientation=squarish',
    chip: 'A16 Bionic',
    display: '6.7" Super Retina XDR ProMotion',
    camera: 'Câmara tripla 48MP + LiDAR',
    capacities: ['128GB', '256GB', '512GB', '1TB'],
    colors: ['Space Black', 'Prata', 'Dourado', 'Roxo Profundo'],
    features: ['Face ID', 'Dynamic Island', 'Câmara 48MP']
  },
  // iPhone 15 Series
  {
    id: 19,
    name: 'iPhone 15',
    year: '2023',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2015%20with%20USB-C%20and%20Dynamic%20Island%20in%20pink%20yellow%20green%20blue%20black%20colors%2C%20aluminum%20frame%20smartphone%20with%20improved%20cameras%2C%20professional%20photography&width=300&height=300&seq=iphone-15-002&orientation=squarish',
    chip: 'A16 Bionic',
    display: '6.1" Super Retina XDR',
    camera: 'Câmara dupla 48MP',
    capacities: ['128GB', '256GB', '512GB'],
    colors: ['Rosa', 'Amarelo', 'Verde', 'Azul', 'Preto'],
    features: ['Face ID', 'USB-C', 'Dynamic Island']
  },
  {
    id: 20,
    name: 'iPhone 15 Plus',
    year: '2023',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2015%20Plus%20large%20screen%20smartphone%20with%20USB-C%20connector%20and%20dual%20camera%20system%2C%20aluminum%20frame%20smartphone%20with%20extended%20battery%20life%2C%20professional%20product%20photography&width=300&height=300&seq=iphone-15-plus-002&orientation=squarish',
    chip: 'A16 Bionic',
    display: '6.7" Super Retina XDR',
    camera: 'Câmara dupla 48MP',
    capacities: ['128GB', '256GB', '512GB'],
    colors: ['Rosa', 'Amarelo', 'Verde', 'Azul', 'Preto'],
    features: ['Face ID', 'USB-C', 'Ecrã grande']
  },
  {
    id: 21,
    name: 'iPhone 15 Pro',
    year: '2023',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2015%20Pro%20with%20titanium%20design%20and%20Action%20Button%20in%20natural%20titanium%20blue%20titanium%20white%20titanium%20black%20titanium%2C%20premium%20smartphone%20with%20AI&width=300&height=300&seq=iphone-15-pro-002&orientation=squarish',
    chip: 'A17 Pro',
    display: '6.1" Super Retina XDR ProMotion',
    camera: 'Câmara tripla 48MP + LiDAR',
    capacities: ['128GB', '256GB', '512GB', '1TB'],
    colors: ['Titânio Natural', 'Titânio Azul', 'Titânio Branco', 'Titânio Preto'],
    features: ['Face ID', 'Titânio', 'Action Button']
  },
  {
    id: 22,
    name: 'iPhone 15 Pro Max',
    year: '2023',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2015%20Pro%20Max%20flagship%20with%20advanced%20Camera%20Control%20and%20Apple%20Intelligence%20AI%20features%2C%20premium%20titanium%20smartphone%20with%20professional%20cameras&width=300&height=300&seq=iphone-15-pro-max-002&orientation=squarish',
    chip: 'A17 Pro',
    display: '6.7" Super Retina XDR ProMotion',
    camera: 'Câmara tripla 48MP + LiDAR',
    capacities: ['256GB', '512GB', '1TB'],
    colors: ['Titânio Natural', 'Titânio Azul', 'Titânio Branco', 'Titânio Preto'],
    features: ['Face ID', 'Titânio', 'Zoom óptico 5x']
  },
  // iPhone 16 Series
  {
    id: 23,
    name: 'iPhone 16',
    year: '2024',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2016%20with%20Camera%20Control%20button%20and%20Apple%20Intelligence%20in%20ultramarine%20teal%20pink%20white%20black%20colors%2C%20aluminum%20frame%20smartphone%20with%20advanced%20AI&width=300&height=300&seq=iphone-16-002&orientation=squarish',
    chip: 'A18',
    display: '6.1" Super Retina XDR',
    camera: 'Câmara dupla 48MP',
    capacities: ['128GB', '256GB', '512GB'],
    colors: ['Ultramarine', 'Teal', 'Rosa', 'Branco', 'Preto'],
    features: ['Face ID', 'Camera Control', 'Apple Intelligence']
  },
  {
    id: 24,
    name: 'iPhone 16 Plus',
    year: '2024',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2016%20Plus%20large%20screen%20smartphone%20with%20Camera%20Control%20and%20Apple%20Intelligence%20features%2C%20aluminum%20frame%20smartphone%20with%20improved%20battery%20and%20AI%20capabilities&width=300&height=300&seq=iphone-16-plus-002&orientation=squarish',
    chip: 'A18',
    display: '6.7" Super Retina XDR',
    camera: 'Câmara dupla 48MP',
    capacities: ['128GB', '256GB', '512GB'],
    colors: ['Ultramarine', 'Teal', 'Rosa', 'Branco', 'Preto'],
    features: ['Face ID', 'Camera Control', 'Apple Intelligence']
  },
  {
    id: 25,
    name: 'iPhone 16 Pro',
    year: '2024',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2016%20Pro%20with%20Camera%20Control%20and%20Apple%20Intelligence%20in%20desert%20titanium%20natural%20titanium%20white%20titanium%20black%20titanium%2C%20premium%20smartphone%20with%20AI&width=300&height=300&seq=iphone-16-pro-002&orientation=squarish',
    chip: 'A18 Pro',
    display: '6.3" Super Retina XDR ProMotion',
    camera: 'Câmara tripla 48MP + LiDAR',
    capacities: ['128GB', '256GB', '512GB', '1TB'],
    colors: ['Titânio Deserto', 'Titânio Natural', 'Titânio Branco', 'Titânio Preto'],
    features: ['Face ID', 'Camera Control', 'Apple Intelligence']
  },
  {
    id: 26,
    name: 'iPhone 16 Pro Max',
    year: '2024',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2016%20Pro%20Max%20flagship%20with%20advanced%20Camera%20Control%20and%20Apple%20Intelligence%20AI%20features%2C%20premium%20titanium%20smartphone%20with%20professional%20cameras&width=300&height=300&seq=iphone-16-pro-max-002&orientation=squarish',
    chip: 'A18 Pro',
    display: '6.9" Super Retina XDR ProMotion',
    camera: 'Câmara tripla 48MP + LiDAR',
    capacities: ['256GB', '512GB', '1TB'],
    colors: ['Titânio Deserto', 'Titânio Natural', 'Titânio Branco', 'Titânio Preto'],
    features: ['Face ID', 'Camera Control', 'Ecrã maior 6.9"']
  },
  // iPhone 17 Pro Series (Future)
  {
    id: 27,
    name: 'iPhone 17 Pro',
    year: '2025',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2017%20Pro%20futuristic%20design%20with%20advanced%20AI%20and%202nm%20chip%20technology%20in%20premium%20titanium%20colors%2C%20next%20generation%20smartphone%20with%20revolutionary%20features&width=300&height=300&seq=iphone-17-pro-002&orientation=squarish',
    chip: 'A19 Pro (2nm)',
    display: '6.3" Super Retina XDR ProMotion',
    camera: 'Câmara tripla 48MP + LiDAR avançado',
    capacities: ['256GB', '512GB', '1TB', '2TB'],
    colors: ['Titânio Platinum', 'Titânio Space', 'Titânio Dourado', 'Titânio Preto'],
    features: ['Face ID avançado', 'A19 Pro 2nm', 'AI revolucionária']
  },
  {
    id: 28,
    name: 'iPhone 17 Pro Max',
    year: '2025',
    image: 'https://readdy.ai/api/search-image?query=iPhone%2017%20Pro%20Max%20ultimate%20flagship%20with%202nm%20chip%20and%20revolutionary%20camera%20system%2C%20premium%20titanium%20construction%20with%20futuristic%20AI%20capabilities&width=300&height=300&seq=iphone-17-pro-max-002&orientation=squarish',
    chip: 'A19 Pro (2nm)',
    display: '6.9" Super Retina XDR ProMotion',
    camera: 'Câmara quádrupla 48MP + LiDAR avançado',
    capacities: ['512GB', '1TB', '2TB'],
    colors: ['Titânio Platinum', 'Titânio Space', 'Titânio Dourado', 'Titânio Preto'],
    features: ['Face ID avançado', 'Zoom óptico 10x', '2TB storage']
  }
];

// Mock data dos produtos de ouro
const goldProducts = [
  {
    id: 1,
    name: 'Aliança Clássica',
    category: 'Alianças',
    weight: '8g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=classic%2018k%20gold%20wedding%20ring%20band%20with%20smooth%20polished%20finish%2C%20traditional%20Portuguese%20jewelry%20design%2C%20elegant%20simple%20style%2C%20professional%20jewelry%20photography%2C%20white%20background&width=300&height=200&seq=alianca-classica-002&orientation=landscape',
    description: 'Aliança tradicional em ouro 18K com acabamento polido.',
    features: ['Ouro 18K puro', 'Acabamento polido', 'Design clássico', 'Garantia vitalícia']
  },
  {
    id: 2,
    name: 'Aliança Diamantada',
    category: 'Alianças',
    weight: '10g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=diamond%20cut%2018k%20gold%20wedding%20ring%20with%20textured%20surface%20pattern%2C%20sparkly%20faceted%20design%2C%20Portuguese%20jewelry%20craftsmanship%2C%20luxury%20wedding%20band%2C%20professional%20photography&width=300&height=200&seq=alianca-diamantada-002&orientation=landscape',
    description: 'Aliança em ouro 18K com acabamento diamantado para maior brilho.',
    features: ['Ouro 18K puro', 'Acabamento diamantado', 'Brilho intenso', 'Resistente']
  },
  {
    id: 3,
    name: 'Anel Solitário',
    category: 'Anéis',
    weight: '5g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20solitaire%20ring%20with%20elegant%20stone%20setting%2C%20classic%20engagement%20ring%20design%2C%20Portuguese%20jewelry%20style%2C%20refined%20luxury%20piece%2C%20professional%20jewelry%20photography&width=300&height=200&seq=anel-solitario-002&orientation=landscape',
    description: 'Elegante anel solitário em ouro 18K, perfeito para pedidos especiais.',
    features: ['Ouro 18K puro', 'Design elegante', 'Cravação segura', 'Acabamento perfeito']
  },
  {
    id: 4,
    name: 'Anel Formatura',
    category: 'Anéis',
    weight: '12g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20graduation%20ring%20with%20university%20symbol%20and%20stone%2C%20Portuguese%20academic%20tradition%20jewelry%2C%20formal%20ceremonial%20ring%20design%2C%20professional%20photography&width=300&height=200&seq=anel-formatura-002&orientation=landscape',
    description: 'Anel de formatura personalizado em ouro 18K com símbolo da instituição.',
    features: ['Ouro 18K puro', 'Personalização disponível', 'Peso substancial', 'Tradição académica']
  },
  {
    id: 5,
    name: 'Anel Feminino Delicado',
    category: 'Anéis',
    weight: '3g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=delicate%2018k%20gold%20womens%20ring%20with%20intricate%20filigree%20pattern%2C%20Portuguese%20traditional%20jewelry%20design%2C%20feminine%20elegant%20style%2C%20fine%20craftsmanship%2C%20professional%20photography&width=300&height=200&seq=anel-feminino-delicado-002&orientation=landscape',
    description: 'Anel feminino delicado em ouro 18K com padrão filigrana.',
    features: ['Ouro 18K puro', 'Design feminino', 'Trabalho artesanal', 'Leve e confortável']
  },
  {
    id: 6,
    name: 'Anel Masculino Robusto',
    category: 'Anéis',
    weight: '15g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=robust%2018k%20gold%20mens%20ring%20with%20bold%20masculine%20design%2C%20heavy%20weight%20signet%20ring%20style%2C%20Portuguese%20jewelry%20craftsmanship%2C%20professional%20photography%2C%20luxury%20mens%20accessory&width=300&height=200&seq=anel-masculino-robusto-002&orientation=landscape',
    description: 'Anel masculino robusto em ouro 18K, ideal para uso diário.',
    features: ['Ouro 18K puro', 'Design masculino', 'Peso robusto', 'Durabilidade superior']
  },
  {
    id: 7,
    name: 'Corrente Portuguesa',
    category: 'Fios & Correntes',
    weight: '20g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=traditional%20Portuguese%2018k%20gold%20chain%20necklace%20with%20classic%20link%20pattern%2C%20authentic%20jewelry%20design%2C%20heritage%20craftsmanship%2C%20professional%20jewelry%20photography&width=300&height=200&seq=corrente-portuguesa-002&orientation=landscape',
    description: 'Corrente tradicional portuguesa em ouro 18K com elos clássicos.',
    features: ['Ouro 18K puro', 'Tradição portuguesa', 'Elos resistentes', 'Fechamento seguro']
  },
  {
    id: 8,
    name: 'Fio Malha',
    category: 'Fios & Correntes',
    weight: '15g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20mesh%20chain%20necklace%20with%20flexible%20weave%20pattern%2C%20Portuguese%20jewelry%20style%2C%20smooth%20comfortable%20wear%2C%20professional%20photography%2C%20luxury%20accessories&width=300&height=200&seq=fio-malha-002&orientation=landscape',
    description: 'Fio malha em ouro 18K, flexível e confortável para uso diário.',
    features: ['Ouro 18K puro', 'Malha flexível', 'Conforto superior', 'Design moderno']
  },
  {
    id: 9,
    name: 'Corrente Corda',
    category: 'Fios & Correntes',
    weight: '18g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20rope%20chain%20necklace%20with%20twisted%20pattern%20design%2C%20durable%20Portuguese%20jewelry%2C%20classic%20masculine%20style%2C%20professional%20photography%2C%20luxury%20gold%20accessory&width=300&height=200&seq=corrente-corda-002&orientation=landscape',
    description: 'Corrente corda em ouro 18K com padrão entrelaçado resistente.',
    features: ['Ouro 18K puro', 'Padrão corda', 'Muito resistente', 'Unissex']
  },
  {
    id: 10,
    name: 'Corrente Singapura',
    category: 'Fios & Correntes',
    weight: '22g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20Singapore%20chain%20necklace%20with%20diamond%20cut%20facets%2C%20oriental%20style%20jewelry%20design%2C%20sparkling%20twisted%20links%2C%20Portuguese%20craftsmanship%2C%20professional%20photography&width=300&height=200&seq=corrente-singapura-002&orientation=landscape',
    description: 'Corrente Singapura em ouro 18K com corte diamantado para máximo brilho.',
    features: ['Ouro 18K puro', 'Corte diamantado', 'Design oriental', 'Brilho excepcional']
  },
  {
    id: 11,
    name: 'Pulseira Tradicional',
    category: 'Pulseiras',
    weight: '12g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=traditional%2018k%20gold%20bracelet%20with%20classic%20Portuguese%20design%2C%20heritage%20jewelry%20style%2C%20elegant%20wrist%20accessory%2C%20professional%20photography%2C%20luxury%20gold%20jewelry&width=300&height=200&seq=pulseira-tradicional-002&orientation=landscape',
    description: 'Pulseira tradicional em ouro 18K com design português clássico.',
    features: ['Ouro 18K puro', 'Design clássico', 'Fechamento seguro', 'Tradição portuguesa']
  },
  {
    id: 12,
    name: 'Pulseira Malha Milanesa',
    category: 'Pulseiras',
    weight: '14g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20Milanese%20mesh%20bracelet%20with%20refined%20weave%20pattern%2C%20Italian%20inspired%20Portuguese%20jewelry%2C%20elegant%20flexible%20design%2C%20professional%20photography&width=300&height=200&seq=pulseira-malha-milanesa-002&orientation=landscape',
    description: 'Pulseira em malha milanesa de ouro 18K, elegante e flexível.',
    features: ['Ouro 18K puro', 'Malha milanesa', 'Ajuste perfeito', 'Elegância italiana']
  },
  {
    id: 13,
    name: 'Pulseira Rígida',
    category: 'Pulseiras',
    weight: '25g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=solid%2018k%20gold%20rigid%20bangle%20bracelet%20with%20smooth%20polished%20finish%2C%20Portuguese%20jewelry%20design%2C%20heavy%20weight%20luxury%20accessory%2C%20professional%20photography&width=300&height=200&seq=pulseira-rigida-002&orientation=landscape',
    description: 'Pulseira rígida em ouro 18K, peça robusta e imponente.',
    features: ['Ouro 18K puro', 'Design rígido', 'Peso substancial', 'Acabamento espelhado']
  },
  {
    id: 14,
    name: 'Pulseira Charm',
    category: 'Pulseiras',
    weight: '16g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20charm%20bracelet%20with%20decorative%20pendant%20elements%2C%20personalized%20jewelry%20style%2C%20Portuguese%20craftsmanship%2C%20professional%20photography%2C%20customizable%20design&width=300&height=200&seq=pulseira-charm-002&orientation=landscape',
    description: 'Pulseira charm em ouro 18K, personalizável com pingentes especiais.',
    features: ['Ouro 18K puro', 'Sistema charm', 'Personalizável', 'Design único']
  },
  {
    id: 15,
    name: 'Brincos Argola',
    category: 'Brincos',
    weight: '6g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20hoop%20earrings%20with%20classic%20circular%20design%2C%20Portuguese%20jewelry%20style%2C%20versatile%20womens%20accessory%2C%20professional%20photography%2C%20elegant%20simplicity&width=300&height=200&seq=brincos-argola-002&orientation=landscape',
    description: 'Brincos argola em ouro 18K, perfeitos para uso diário.',
    features: ['Ouro 18K puro', 'Design atemporal', 'Fechamento seguro', 'Uso diário']
  },
  {
    id: 16,
    name: 'Brincos Gota',
    category: 'Brincos',
    weight: '8g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20drop%20earrings%20with%20elegant%20teardrop%20design%2C%20Portuguese%20jewelry%20craftsmanship%2C%20feminine%20sophisticated%20style%2C%20professional%20photography&width=300&height=200&seq=brincos-gota-002&orientation=landscape',
    description: 'Brincos gota em ouro 18K com design sofisticado e feminino.',
    features: ['Ouro 18K puro', 'Design gota', 'Movimento elegante', 'Ocasiões especiais']
  },
  {
    id: 17,
    name: 'Brincos Botão',
    category: 'Brincos',
    weight: '4g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20stud%20earrings%20with%20polished%20button%20design%2C%20classic%20Portuguese%20jewelry%2C%20simple%20elegant%20style%2C%20professional%20photography%2C%20daily%20wear%20accessory&width=300&height=200&seq=brincos-botao-002&orientation=landscape',
    description: 'Brincos botão em ouro 18K, perfeitos para uso diário.',
    features: ['Ouro 18K puro', 'Design discreto', 'Conforto total', 'Versatilidade']
  },
  {
    id: 18,
    name: 'Pingente Cruz',
    category: 'Pingentes',
    weight: '7g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20cross%20pendant%20with%20religious%20Christian%20symbol%2C%20Portuguese%20traditional%20jewelry%2C%20faith%20accessory%2C%20professional%20photography%2C%20spiritual%20significance&width=300&height=200&seq=pingente-cruz-002&orientation=landscape',
    description: 'Pingente cruz em ouro 18K, símbolo de fé e proteção.',
    features: ['Ouro 18K puro', 'Símbolo religioso', 'Proteção espiritual', 'Design clássico']
  },
  {
    id: 19,
    name: 'Pingente Coração',
    category: 'Pingentes',
    weight: '5g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=18k%20gold%20heart%20pendant%20with%20romantic%20love%20symbol%2C%20Portuguese%20jewelry%20design%2C%20gift%20accessory%2C%20professional%20photography%2C%20emotional%20significance&width=300&height=200&seq=pingente-coracao-002&orientation=landscape',
    description: 'Pingente coração em ouro 18K, símbolo de amor e carinho.',
    features: ['Ouro 18K puro', 'Símbolo do amor', 'Presente ideal', 'Significado emocional']
  },
  {
    id: 20,
    name: 'Pingente Personalizado',
    category: 'Pingentes',
    weight: '9g',
    karat: '18K',
    image: 'https://readdy.ai/api/search-image?query=custom%2018k%20gold%20pendant%20with%20personalized%20engraving%2C%20Portuguese%20jewelry%20craftsmanship%2C%20bespoke%20design%2C%20professional%20photography%2C%20unique%20accessory&width=300&height=200&seq=pingente-personalizado-002&orientation=landscape',
    description: 'Pingente personalizado em ouro 18K com gravação exclusiva.',
    features: ['Ouro 18K puro', 'Gravação personalizada', 'Design exclusivo', 'Significado único']
  }
];

export default function LojaServicosPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('Todas');
  const [zoomOpen, setZoomOpen] = useState(false);
  const [currentZoomIndex, setCurrentZoomIndex] = useState(0);
  const [zoomType, setZoomType] = useState('iphone'); // 'iphone' ou 'gold'
  const [activeSection, setActiveSection] = useState('telemoveis');
  const [showStickyNav, setShowStickyNav] = useState(false);

  const categories = ['Todas', 'Alianças', 'Anéis', 'Fios & Correntes', 'Pulseiras', 'Brincos', 'Pingentes'];

  const filteredGoldProducts = selectedCategory === 'Todas' 
    ? goldProducts 
    : goldProducts.filter(product => product.category === selectedCategory);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
      setShowStickyNav(scrollPosition > 300);
      
      // Detectar seção ativa
      const sections = ['telemoveis', 'ouro'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 200 && rect.bottom > 200;
        }
        return false;
      });
      
      if (current) setActiveSection(current);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openZoom = (index, type) => {
    setCurrentZoomIndex(index);
    setZoomType(type);
    setZoomOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeZoom = () => {
    setZoomOpen(false);
    document.body.style.overflow = 'unset';
  };

  const goToNext = () => {
    const items = zoomType === 'iphone' ? iphones : filteredGoldProducts;
    setCurrentZoomIndex((prev) => (prev + 1) % items.length);
  };

  const goToPrevious = () => {
    const items = zoomType === 'iphone' ? iphones : filteredGoldProducts;
    setCurrentZoomIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  // Navegação por teclado
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!zoomOpen) return;
      
      if (e.key === 'Escape') {
        closeZoom();
      } else if (e.key === 'ArrowLeft') {
        goToPrevious();
      } else if (e.key === 'ArrowRight') {
        goToNext();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [zoomOpen, currentZoomIndex, zoomType]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navegação Principal */}
      <nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/90 backdrop-blur-md'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/821bfe14b1fc609bf2a57dd541a10a42.png" 
                alt="FF TRAVEL - Agência de Viagens" 
                className="h-32 md:h-36"
                loading="eager"
              />
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Início
              </Link>
              <Link to="/agencia-viagens" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Agência de Viagens
              </Link>
              <Link to="/loja-servicos" className="text-[#ff6b35] font-semibold">
                Loja & Serviços
              </Link>
              <Link to="/sobre" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Sobre
              </Link>
              <Link to="/contactos" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Contactos
              </Link>
            </div>

            <a 
              href="https://wa.me/244936769113" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hidden md:block bg-[#ff6b35] text-white px-6 py-3 rounded-full font-medium hover:bg-[#ff5722] transition-all shadow-md whitespace-nowrap cursor-pointer"
            >
              Pedir Cotação
            </a>
          </div>
        </div>
      </nav>

      {/* Navegação Flutuante Sticky */}
      {showStickyNav && (
        <div className="fixed top-24 left-1/2 transform -translate-x-1/2 z-30 animate-slide-down">
          <div className="bg-white/95 backdrop-blur-md rounded-full px-8 py-4 shadow-2xl border border-gray-200/50">
            <div className="flex items-center gap-6">
              <button
                onClick={() => scrollToSection('telemoveis')}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeSection === 'telemoveis' 
                    ? 'bg-[#ff6b35] text-white shadow-lg scale-105' 
                    : 'text-[#1e40af] hover:bg-[#ff6b35]/10 hover:text-[#ff6b35]'
                }`}
              >
                📱 iPhones
              </button>
              <div className="w-px h-8 bg-gray-300"></div>
              <button
                onClick={() => scrollToSection('ouro')}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeSection === 'ouro' 
                    ? 'bg-[#ff6b35] text-white shadow-lg scale-105' 
                    : 'text-[#1e40af] hover:bg-[#ff6b35]/10 hover:text-[#ff6b35]'
                }`}
              >
                💎 Ouro
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1e40af] to-[#1e3a8a] overflow-hidden">
        {/* Elementos decorativos de fundo */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#ff6b35]/10 rounded-full blur-3xl animate-pulse-slow animation-delay-500"></div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center text-white animate-fade-in">
            {/* Badge Flutuante Melhorado */}
            <div className="inline-block bg-[#ff6b35]/20 backdrop-blur-sm border-2 border-[#ff6b35] text-[#ff6b35] px-8 py-4 rounded-full text-lg font-bold mb-8 animate-bounce-slow shadow-2xl" 
                 style={{ 
                   boxShadow: '0 0 30px rgba(255, 107, 53, 0.6), 0 0 60px rgba(255, 107, 53, 0.4)' 
                 }}>
              🔥 PROMOÇÕES EXCLUSIVAS APPLE & JOIAS
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-slide-up">
              Loja & Serviços FFTravel
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto animate-slide-up" style={{ animationDelay: '0.2s' }}>
              iPhones originais e compra/venda de ouro com os melhores preços de Angola
            </p>
            
            {/* Indicadores de Seção */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10 animate-slide-up" style={{ animationDelay: '0.4s' }}>
              <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="text-3xl">📱</span>
                <span className="font-semibold">28 Modelos iPhone</span>
              </div>
              <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="text-3xl">💎</span>
                <span className="font-semibold">Compra & Venda de Ouro 18K</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Indicador de Progresso Visual */}
      <div className="sticky top-0 z-20 h-1 bg-gray-200">
        <div 
          className="h-full bg-gradient-to-r from-[#ff6b35] to-[#1e40af] transition-all duration-300"
          style={{ 
            width: `${Math.min(100, (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100)}%` 
          }}
        ></div>
      </div>

      {/* Secção iPhones */}
      <section id="telemoveis" className="py-24 bg-white relative overflow-hidden">
        {/* Elementos decorativos de fundo */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#1e40af]/5 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#ff6b35]/5 rounded-full blur-3xl animate-pulse-slow animation-delay-500"></div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* Cabeçalho da Seção Melhorado */}
          <div className="text-center mb-16 scroll-reveal">
            {/* Logo FF MOBILE */}
            <div className="flex justify-center mb-8">
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/9cbd3cf1e5d3caa5e34987faea0c85a6.jpeg"
                alt="FF MOBILE - Venda de Telemóveis e Acessórios"
                className="h-32 md:h-40 animate-bounce-slow hover-scale"
                loading="lazy"
              />
            </div>

            <div className="inline-flex items-center gap-3 bg-[#ff6b35]/10 text-[#ff6b35] px-8 py-4 rounded-full text-lg font-bold mb-8 animate-bounce-slow shadow-lg">
              <span className="text-2xl">🍎</span>
              <span>APPLE STORE PREMIUM</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a8a] mb-6">
              iPhones Originais
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
              Coleção completa desde iPhone XR até iPhone 17 Pro Max com garantia e suporte técnico
            </p>
            
            {/* Estatísticas Visuais */}
            <div className="flex flex-wrap justify-center gap-6">
              <div className="bg-gradient-to-r from-[#1e40af] to-[#1e3a8a] text-white px-6 py-3 rounded-full shadow-lg">
                <span className="font-bold text-lg">28 Modelos</span>
              </div>
              <div className="bg-gradient-to-r from-[#ff6b35] to-[#ff5722] text-white px-6 py-3 rounded-full shadow-lg">
                <span className="font-bold text-lg">Garantia Apple</span>
              </div>
              <div className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-full shadow-lg">
                <span className="font-bold text-lg">100% Originais</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {iphones.map((iphone, index) => (
              <div 
                key={iphone.id} 
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 group relative scroll-reveal hover-lift border border-gray-100"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                {/* Badge de Ano */}
                <div className="absolute top-4 left-4 z-10">
                  <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                    iphone.year === '2025' 
                      ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white animate-pulse' 
                      : iphone.year === '2024'
                      ? 'bg-gradient-to-r from-[#ff6b35] to-[#ff5722] text-white'
                      : 'bg-gray-100 text-gray-600'
                  }`}>
                    {iphone.year}
                  </span>
                </div>

                {/* Badge Promocional */}
                <div className="absolute top-4 right-4 z-10">
                  <span className={`px-3 py-1 rounded-full text-xs font-bold animate-bounce-slow ${
                    iphone.name.includes('17') 
                      ? 'bg-red-500 text-white' 
                      : iphone.name.includes('16')
                      ? 'bg-[#ff6b35] text-white'
                      : iphone.name.includes('15')
                      ? 'bg-blue-500 text-white'
                      : 'bg-green-500 text-white'
                  }`}>
                    {iphone.name.includes('17') 
                      ? '🔥 NOVIDADE 2025' 
                      : iphone.name.includes('16')
                      ? 'Apple Intelligence'
                      : iphone.name.includes('15')
                      ? 'USB-C Finalmente'
                      : 'Promoção Especial'
                    }
                  </span>
                </div>

                {/* Ícone de Zoom */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20 pointer-events-none">
                  <div className="w-16 h-16 bg-black/80 rounded-full flex items-center justify-center animate-pulse">
                    <i className="ri-zoom-in-line text-white text-3xl"></i>
                  </div>
                </div>

                {/* Imagem - Lazy Loading */}
                <div className="relative mb-6 cursor-pointer" onClick={() => openZoom(index, 'iphone')}>
                  <img
                    src={iphone.image}
                    alt={iphone.name}
                    className="w-full h-64 object-contain rounded-lg group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>

                <div className="text-center">
                  <h3 className="text-xl font-bold text-[#1e3a8a] mb-3 group-hover:text-[#ff6b35] transition-colors">
                    {iphone.name}
                  </h3>
                  
                  {/* Especificações Simplificadas */}
                  <div className="space-y-2 mb-6 text-sm text-gray-600">
                    <div className="flex items-center justify-center gap-2">
                      <i className="ri-cpu-line text-[#ff6b35]"></i>
                      <span>{iphone.chip}</span>
                    </div>
                    <div className="flex items-center justify-center gap-2">
                      <i className="ri-smartphone-line text-[#ff6b35]"></i>
                      <span>{iphone.display}</span>
                    </div>
                    <div className="flex items-center justify-center gap-2">
                      <i className="ri-camera-line text-[#ff6b35]"></i>
                      <span>{iphone.camera}</span>
                    </div>
                  </div>

                  {/* Capacidades */}
                  <div className="flex flex-wrap justify-center gap-2">
                    {iphone.capacities.slice(0, 3).map((capacity, idx) => (
                      <span 
                        key={idx}
                        className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-medium hover:bg-[#ff6b35] hover:text-white transition-colors cursor-pointer"
                      >
                        {capacity}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Final da Seção */}
          <div className="text-center mt-16 scroll-reveal">
            <div className="bg-gradient-to-r from-[#1e40af] to-[#1e3a8a] rounded-3xl p-12 text-white relative overflow-hidden">
              <div className="absolute inset-0 bg-black/20"></div>
              <div className="relative z-10">
                {/* Logo FF MOBILE no CTA */}
                <div className="flex justify-center mb-6">
                  <img 
                    src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/9cbd3cf1e5d3caa5e34987faea0c85a6.jpeg"
                    alt="FF MOBILE"
                    className="h-16 opacity-80 animate-pulse-slow"
                    loading="lazy"
                  />
                </div>
                <h3 className="text-3xl font-bold mb-4">Não encontrou o modelo que procura?</h3>
                <p className="text-xl text-white/90 mb-8">Entre em contacto connosco para consultar disponibilidade</p>
                <a 
                  href="https://wa.me/244936769113" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 bg-[#ff6b35] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all duration-300 shadow-2xl cursor-pointer hover-lift hover-glow"
                >
                  <i className="ri-whatsapp-line text-2xl"></i>
                  Consultar iPhone
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Separador Visual */}
      <div className="h-24 bg-gradient-to-r from-[#1e40af] via-[#ff6b35] to-[#1e40af] relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-pulse"></div>
        <div className="flex items-center justify-center h-full">
          <div className="flex items-center gap-6 text-white">
            <i className="ri-smartphone-line text-3xl animate-bounce"></i>
            <div className="w-16 h-1 bg-white/50 rounded-full"></div>
            <i className="ri-diamond-line text-3xl animate-bounce animation-delay-500"></i>
          </div>
        </div>
      </div>

      {/* Secção Compra de Ouro */}
      <section id="ouro" className="py-24 bg-gray-50 relative overflow-hidden">
        {/* Elementos decorativos */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400/5 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-400/5 rounded-full blur-3xl animate-pulse-slow animation-delay-500"></div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* Cabeçalho da Seção Melhorado */}
          <div className="text-center mb-16 scroll-reveal">
            <div className="inline-flex items-center gap-3 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-8 py-4 rounded-full text-lg font-bold mb-8 animate-bounce-slow shadow-lg">
              <span className="text-2xl">👑</span>
              <span>JOALHARIA PREMIUM</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a8a] mb-6">
              Compra & Venda de Ouro 18K
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed mb-4">
              <strong className="text-[#ff6b35]">Compramos e vendemos</strong> todo tipo de ouro 18K: alianças, anéis, fios, pulseiras, brincos e pingentes
            </p>
            <p className="text-gray-500 text-base max-w-2xl mx-auto">
              Seja para comprar joias de qualidade ou vender o seu ouro, oferecemos os melhores preços de Angola
            </p>
            
            {/* Destaque de Garantias */}
            <div className="flex flex-wrap justify-center gap-6">
              <div className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-6 py-3 rounded-full shadow-lg">
                <span className="font-bold text-lg">💰 Compramos Ouro</span>
              </div>
              <div className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-full shadow-lg">
                <span className="font-bold text-lg">💎 Vendemos Ouro</span>
              </div>
              <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-3 rounded-full shadow-lg">
                <span className="font-bold text-lg">⚖️ Melhor Preço</span>
              </div>
            </div>
          </div>

          {/* Filtros de Categoria Melhorados */}
          <div className="mb-12 scroll-reveal">
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-200">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-[#1e3a8a] mb-2">Categorias Disponíveis</h3>
                <p className="text-gray-600">Filtre por tipo de joia para ver os produtos que compramos</p>
              </div>
              
              <div className="flex flex-wrap justify-center gap-3">
                {categories.map((category) => {
                  const count = category === 'Todas' 
                    ? goldProducts.length 
                    : goldProducts.filter(p => p.category === category).length;
                  
                  return (
                    <button
                      key={category}
                      onClick={() => setSelectedCategory(category)}
                      className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg flex items-center gap-2 ${
                        selectedCategory === category
                          ? 'bg-gradient-to-r from-[#ff6b35] to-[#ff5722] text-white transform scale-105 shadow-xl'
                          : 'bg-white text-gray-700 hover:bg-[#ff6b35]/10 hover:text-[#ff6b35] border border-gray-200'
                      }`}
                    >
                      <span>{category}</span>
                      <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                        selectedCategory === category
                          ? 'bg-white/20 text-white'
                          : 'bg-gray-100 text-gray-600'
                      }`}>
                        {count}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Grid de Produtos */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {filteredGoldProducts.map((product, index) => (
              <div 
                key={product.id} 
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 group relative scroll-reveal hover-lift border border-gray-100"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                {/* Badge de Quilates */}
                <div className="absolute top-4 left-4 z-10">
                  <span className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold animate-pulse">
                    {product.karat}
                  </span>
                </div>

                {/* Badge de Categoria */}
                <div className="absolute top-4 right-4 z-10">
                  <span className="bg-[#1e40af] text-white px-3 py-1 rounded-full text-xs font-bold">
                    {product.category}
                  </span>
                </div>

                {/* Ícone de Zoom */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20 pointer-events-none">
                  <div className="w-16 h-16 bg-black/80 rounded-full flex items-center justify-center animate-pulse">
                    <i className="ri-zoom-in-line text-white text-3xl"></i>
                  </div>
                </div>

                {/* Imagem - Lazy Loading */}
                <div className="relative mb-6 cursor-pointer" onClick={() => openZoom(index, 'gold')}>
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-48 object-cover rounded-lg group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>

                <div className="text-center">
                  <h3 className="text-xl font-bold text-[#1e3a8a] mb-3 group-hover:text-[#ff6b35] transition-colors">
                    {product.name}
                  </h3>
                  
                  {/* Informações Principais */}
                  <div className="flex justify-center items-center gap-4 mb-4">
                    <div className="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-full">
                      <i className="ri-scales-3-line text-[#ff6b35] text-lg"></i>
                      <span className="text-sm font-semibold text-gray-700">{product.weight}</span>
                    </div>
                    <div className="flex items-center gap-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-2 rounded-full">
                      <i className="ri-vip-crown-line text-lg"></i>
                      <span className="text-sm font-bold">{product.karat}</span>
                    </div>
                  </div>

                  <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                    {product.description}
                  </p>

                  {/* Botões de Ação */}
                  <div className="flex gap-3">
                    <button
                      onClick={() => openZoom(index, 'gold')}
                      className="flex-1 bg-[#1e40af] text-white py-3 px-4 rounded-full font-semibold hover:bg-[#1e3a8a] transition-all duration-300 text-sm whitespace-nowrap cursor-pointer hover-lift"
                    >
                      Ver
                    </button>
                    <a
                      href="https://wa.me/244936769113"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 bg-gradient-to-r from-[#ff6b35] to-[#ff5722] text-white py-3 px-4 rounded-full font-semibold hover:shadow-lg transition-all duration-300 text-sm whitespace-nowrap cursor-pointer hover-lift text-center"
                    >
                      Preço
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Mensagem quando não há produtos */}
          {filteredGoldProducts.length === 0 && (
            <div className="text-center py-20">
              <i className="ri-search-line text-6xl text-gray-400 mb-6"></i>
              <h3 className="text-2xl font-bold text-gray-600 mb-4">
                Nenhum produto encontrado nesta categoria
              </h3>
              <p className="text-gray-500 mb-8">
                Tente selecionar outra categoria ou contacte-nos para mais informações
              </p>
              <a 
                href="https://wa.me/244936769113" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-[#ff6b35] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#ff5722] transition-all cursor-pointer"
              >
                Falar Conosco
              </a>
            </div>
          )}

          {/* CTA Final da Seção Ouro */}
          <div className="text-center scroll-reveal">
            <div className="bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 rounded-3xl p-12 text-white relative overflow-hidden shadow-2xl">
              <div className="absolute inset-0 bg-black/20"></div>
              <div className="relative z-10">
                <div className="flex items-center justify-center gap-4 mb-6">
                  <i className="ri-vip-diamond-line text-5xl animate-bounce"></i>
                  <i className="ri-coins-line text-5xl animate-bounce animation-delay-200"></i>
                  <i className="ri-trophy-line text-5xl animate-bounce animation-delay-400"></i>
                </div>
                <h3 className="text-3xl font-bold mb-4">Quer Comprar ou Vender Ouro?</h3>
                <p className="text-xl text-white/90 mb-8">
                  <strong>Compramos</strong> o seu ouro com avaliação gratuita e pagamento imediato<br/>
                  <strong>Vendemos</strong> joias de ouro 18K com os melhores preços de Angola
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a 
                    href="https://wa.me/244936769113" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-white text-orange-500 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 shadow-xl cursor-pointer hover-lift"
                  >
                    <i className="ri-whatsapp-line text-2xl"></i>
                    Falar Conosco
                  </a>
                  <a 
                    href="tel:+244936769113" 
                    className="inline-flex items-center gap-3 bg-white/20 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white/30 transition-all duration-300 cursor-pointer hover-lift"
                  >
                    <i className="ri-phone-line text-2xl"></i>
                    Ligar Agora
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal de Zoom */}
      {zoomOpen && (
        <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center animate-fade-in">
          <button
            onClick={closeZoom}
            className="absolute top-6 right-6 w-14 h-14 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-all duration-300 z-10 cursor-pointer hover-scale"
          >
            <i className="ri-close-line text-3xl"></i>
          </button>

          <div className="absolute top-6 left-6 text-white text-lg font-semibold z-10 animate-slide-in-left">
            {currentZoomIndex + 1} / {zoomType === 'iphone' ? iphones.length : filteredGoldProducts.length}
          </div>

          <button
            onClick={goToPrevious}
            className="absolute left-6 w-16 h-16 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-all duration-300 cursor-pointer hover-scale"
          >
            <i className="ri-arrow-left-s-line text-4xl"></i>
          </button>

          <div className="max-w-6xl max-h-[90vh] mx-auto px-24 animate-scale-in">
            {zoomType === 'iphone' ? (
              <div className="bg-white rounded-3xl overflow-hidden shadow-2xl">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                  <div className="p-8">
                    <img
                      src={iphones[currentZoomIndex].image}
                      alt={iphones[currentZoomIndex].name}
                      className="w-full h-96 object-contain rounded-2xl"
                      loading="eager"
                    />
                  </div>
                  <div className="p-8 bg-gray-50">
                    <div className="flex items-center gap-3 mb-4">
                      <span className="bg-[#ff6b35] text-white px-3 py-1 rounded-full text-sm font-bold">
                        {iphones[currentZoomIndex].year}
                      </span>
                      <span className="text-2xl">🍎</span>
                    </div>
                    <h3 className="text-3xl font-bold text-[#1e3a8a] mb-6">{iphones[currentZoomIndex].name}</h3>
                    
                    <div className="space-y-4 mb-8">
                      <div className="flex items-center gap-3">
                        <i className="ri-cpu-line text-2xl text-[#ff6b35]"></i>
                        <span className="text-lg">{iphones[currentZoomIndex].chip}</span>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="ri-smartphone-line text-2xl text-[#ff6b35]"></i>
                        <span className="text-lg">{iphones[currentZoomIndex].display}</span>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="ri-camera-line text-2xl text-[#ff6b35]"></i>
                        <span className="text-lg">{iphones[currentZoomIndex].camera}</span>
                      </div>
                    </div>

                    <div className="mb-8">
                      <p className="text-sm text-gray-500 mb-3">Capacidades Disponíveis:</p>
                      <div className="flex flex-wrap gap-2">
                        {iphones[currentZoomIndex].capacities.map((capacity, idx) => (
                          <span key={idx} className="bg-[#1e40af] text-white px-4 py-2 rounded-full text-sm font-semibold">
                            {capacity}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="mb-8">
                      <p className="text-sm text-gray-500 mb-3">Cores:</p>
                      <div className="flex flex-wrap gap-2">
                        {iphones[currentZoomIndex].colors.map((color, idx) => (
                          <span key={idx} className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm">
                            {color}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="mb-8">
                      <p className="text-sm text-gray-500 mb-3">Características:</p>
                      <ul className="space-y-3">
                        {iphones[currentZoomIndex].features.map((feature, idx) => (
                          <li key={idx} className="flex items-center gap-3">
                            <i className="ri-check-line text-xl text-green-500"></i>
                            <span className="text-gray-700">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <a
                      href="https://wa.me/244936769113"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full bg-[#ff6b35] text-white py-4 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all duration-300 cursor-pointer text-center block"
                    >
                      Solicitar Preço
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-3xl overflow-hidden shadow-2xl">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                  <div className="p-8">
                    <img
                      src={filteredGoldProducts[currentZoomIndex].image}
                      alt={filteredGoldProducts[currentZoomIndex].name}
                      className="w-full h-96 object-cover rounded-2xl"
                      loading="eager"
                    />
                  </div>
                  <div className="p-8 bg-gradient-to-br from-yellow-50 to-orange-500">
                    <div className="flex items-center gap-3 mb-4">
                      <span className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-4 py-2 rounded-full text-sm font-bold">
                        {filteredGoldProducts[currentZoomIndex].karat}
                      </span>
                      <span className="bg-[#1e40af] text-white px-3 py-1 rounded-full text-sm">
                        {filteredGoldProducts[currentZoomIndex].category}
                      </span>
                    </div>
                    <h3 className="text-3xl font-bold text-[#1e3a8a] mb-4">{filteredGoldProducts[currentZoomIndex].name}</h3>
                    <p className="text-lg text-gray-700 mb-8">{filteredGoldProducts[currentZoomIndex].description}</p>

                    <div className="grid grid-cols-2 gap-4 mb-8">
                      <div className="bg-white p-4 rounded-xl text-center">
                        <i className="ri-scales-3-line text-3xl text-[#ff6b35] mb-2"></i>
                        <p className="text-sm text-gray-500 mb-1">Peso</p>
                        <p className="text-xl font-bold text-gray-800">{filteredGoldProducts[currentZoomIndex].weight}</p>
                      </div>
                      <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white p-4 rounded-xl text-center">
                        <i className="ri-vip-crown-line text-3xl mb-2"></i>
                        <p className="text-sm mb-1">Qualidade</p>
                        <p className="text-xl font-bold">{filteredGoldProducts[currentZoomIndex].karat}</p>
                      </div>
                    </div>

                    <div className="mb-8">
                      <p className="text-sm text-gray-500 mb-4">Características:</p>
                      <ul className="space-y-3">
                        {filteredGoldProducts[currentZoomIndex].features.map((feature, idx) => (
                          <li key={idx} className="flex items-center gap-3">
                            <i className="ri-check-line text-xl text-green-500"></i>
                            <span className="text-gray-700">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <a
                      href="https://wa.me/244936769113"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full bg-gradient-to-r from-[#ff6b35] to-[#ff5722] text-white py-4 rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 cursor-pointer text-center block"
                    >
                      Solicitar Avaliação
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>

          <button
            onClick={goToNext}
            className="absolute right-6 w-16 h-16 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-all duration-300 cursor-pointer hover-scale"
          >
            <i className="ri-arrow-right-s-line text-4xl"></i>
          </button>
        </div>
      )}

      {/* CTA Final */}
      <section className="py-24 bg-gradient-to-br from-[#1e40af] to-[#1e3a8a] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl animate-float"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#ff6b35] rounded-full blur-3xl animate-float animation-delay-500"></div>
        </div>
        
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10 scroll-reveal">
          <div className="flex items-center justify-center gap-6 mb-8">
            <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center animate-bounce-slow">
              <i className="ri-smartphone-line text-3xl text-white"></i>
            </div>
            <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center animate-bounce-slow animation-delay-200">
              <i className="ri-diamond-line text-3xl text-white"></i>
            </div>
            <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center animate-bounce-slow animation-delay-400">
              <i className="ri-customer-service-2-line text-3xl text-white"></i>
            </div>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Precisa de Mais Informações?
          </h2>
          <p className="text-xl text-white/90 mb-10">
            Entre em contacto para consultar preços, disponibilidade e condições especiais
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/244936769113" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#22c55e] transition-all duration-300 shadow-2xl cursor-pointer hover-lift hover-glow"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              WhatsApp Direto
            </a>
            <a 
              href="tel:+244936769113" 
              className="inline-flex items-center gap-3 bg-[#ff6b35] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all duration-300 shadow-2xl cursor-pointer hover-lift"
            >
              <i className="ri-phone-line text-2xl"></i>
              Ligar Agora
            </a>
          </div>
        </div>
      </section>

      {/* Rodapé */}
      <footer className="bg-black text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/e349152b587c7809cba7381685cd68b4.png" 
                alt="FF TRAVEL - Agência de Viagens" 
                className="h-32 md:h-36 mb-8"
                loading="lazy"
              />
              <p className="text-white/70 leading-relaxed mb-4">
                FF Prestação & Serviço, Lda
              </p>
              <p className="text-white/50 text-sm mb-6">
                NIF: 500714988
              </p>
              
              {/* Redes Sociais - DESTAQUE */}
              <div className="mb-6">
                <p className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">
                  Siga-nos
                </p>
                <div className="flex gap-3">
                  <a 
                    href="https://www.instagram.com/ff_travel_angola/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 hover:scale-110 rounded-xl flex items-center justify-center transition-all shadow-lg cursor-pointer"
                    title="Instagram"
                  >
                    <i className="ri-instagram-line text-2xl text-white"></i>
                  </a>
                  <a 
                    href="https://www.facebook.com/share/1AVqwyfH7E/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-[#1877F2] hover:scale-110 rounded-xl flex items-center justify-center transition-all shadow-lg cursor-pointer"
                    title="Facebook"
                  >
                    <i className="ri-facebook-fill text-2xl text-white"></i>
                  </a>
                  <a 
                    href="https://www.linkedin.com/company/ff-travel" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-[#0A66C2] hover:scale-110 rounded-xl flex items-center justify-center transition-all shadow-lg cursor-pointer"
                    title="LinkedIn"
                  >
                    <i className="ri-linkedin-fill text-2xl text-white"></i>
                  </a>
                </div>
              </div>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Contactos</p>
              <div className="space-y-3">
                <a href="tel:+244936769113" className="block text-white hover:text-[#ff6b35] transition-colors">+244 936 769 113</a>
                <a href="tel:+244927606910" className="block text-white hover:text-[#ff6b35] transition-colors">+244 927 606 910</a>
              </div>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Localização</p>
              <p className="text-white/70 leading-relaxed">
                Rua do Campo do Escoqueiro<br />
                De frente ao prédio do Cucu<br />
                Luanda, Angola
              </p>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Links Rápidos</p>
              <div className="space-y-3">
                <Link to="/" className="block text-white hover:text-[#ff6b35] transition-colors">Início</Link>
                <Link to="/agencia-viagens" className="block text-white hover:text-[#ff6b35] transition-colors">Agência de Viagens</Link>
                <Link to="/contactos" className="block text-white hover:text-[#ff6b35] transition-colors">Contactos</Link>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © 2025 FF TRAVEL. Todos os direitos reservados.
            </p>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white transition-colors cursor-pointer text-sm">Powered by Readdy</a>
          </div>
        </div>
      </footer>

      {/* Botão WhatsApp Flutuante */}
      <a 
        href="https://wa.me/244936769113" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center text-white shadow-2xl hover:scale-110 transition-transform z-50 animate-pulse cursor-pointer"
        style={{ boxShadow: '0 8px 24px rgba(255, 107, 53, 0.4)' }}
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>

      {/* Estilos CSS personalizados */}
      <style jsx>{`
        .scroll-reveal {
          opacity: 0;
          transform: translateY(30px);
          animation: revealUp 0.8s ease-out forwards;
        }

        .hover-lift:hover {
          transform: translateY(-4px);
        }

        .hover-scale:hover {
          transform: scale(1.05);
        }

        .hover-glow:hover {
          box-shadow: 0 0 30px rgba(255, 107, 53, 0.6);
        }

        .animate-fade-in {
          animation: fadeIn 0.5s ease-out;
        }

        .animate-slide-up {
          animation: slideUp 0.8s ease-out;
        }

        .animate-slide-down {
          animation: slideDown 0.8s ease-out;
        }

        .animate-slide-in-left {
          animation: slideInLeft 0.6s ease-out;
        }

        .animate-scale-in {
          animation: scaleIn 0.5s ease-out;
        }

        .animate-bounce-slow {
          animation: bounceSlow 2s infinite;
        }

        .animate-pulse-slow {
          animation: pulseSlow 3s infinite;
        }

        .animate-float {
          animation: float 6s ease-in-out infinite;
        }

        .animation-delay-200 { animation-delay: 0.2s; }
        .animation-delay-400 { animation-delay: 0.4s; }
        .animation-delay-500 { animation-delay: 0.5s; }
        .animation-delay-600 { animation-delay: 0.6s; }

        @keyframes revealUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes bounceSlow {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }

        @keyframes pulseSlow {
          0%, 100% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
      `}</style>
    </div>
  );
}
